<header class="lh-header">
  <div class="lh-header-inner">
    <a class="lh-brand" [routerLink]="['/', modulePath]" [queryParams]="{ lang: lang }">{{
      'learningHub.title' | lhTranslate: lang
    }}</a>
  </div>
</header>
